import { ApiUrls } from '@api/apiUrls';
import { fetchApi, FetchApiResponse } from '@api/fetchApi';
import { IApiSelfTradingAccountTypeViewModel } from '@api/interfaces/data-contracts';

export const apiTradingAccountTypeUser = {
  getSelfTradingTypes: async (filter?: {
    contestId?: string | number | null;
  }): Promise<FetchApiResponse<IApiSelfTradingAccountTypeViewModel[]>> => {
    return await fetchApi.get<IApiSelfTradingAccountTypeViewModel[]>(
      ApiUrls.tradingAccountTypeUser.getSelfTradingTypes,
      { params: { contestId: filter?.contestId } },
    );
  },
};
